import {
  MDBBtn,
  MDBNavbar,
  MDBContainer,
  MDBInput,
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
  MDBPopover,
  MDBPopoverBody,
  MDBPopoverHeader,
  MDBInputGroup,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { exportData } from "../../../helper/export";

const getCurrentDate = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const Header = ({
  setSideNavToggle,
  sideNavToggle,
  dataForExport,
  setBillSearchText,
  loadExportData,
  exportDataReady,
  setExportDataReady,
  setOffset,
  sessionInfoForHeader,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [isCsv, setIsCsv] = useState(false);
  const [isPdf, setIsPdf] = useState(false);
  const [exportDataCache, setExportDataCache] = useState(null);

  const handleCsvClick = async () => {
    setIsDownloading(true);
    setIsCsv(true);
    setIsPdf(false);
    setExportDataCache(null);
    await loadExportData({ formatToExport: "CSV" });
  };

  const handlePdfClick = async () => {
    setIsDownloading(true);
    setIsPdf(true);
    setIsCsv(false);
    setExportDataCache(null);
    await loadExportData({ formatToExport: "PDF" });
  };

  useEffect(() => {
    if (exportDataReady && dataForExport) {
      console.log(
        "Starting export process with",
        dataForExport.length,
        "records"
      );
      handleExport();
    }
  }, [exportDataReady, dataForExport]);

  const handleExport = async () => {
    if (!dataForExport || !Array.isArray(dataForExport)) {
      console.error("No valid export data available");
      setIsDownloading(false);
      setIsCsv(false);
      setIsPdf(false);
      return;
    }

    try {
      console.log(`Processing ${dataForExport.length} records for export`);

      if (isCsv) {
        await exportData(
          dataForExport,
          `Filtered_Bills_${getCurrentDate()}`,
          "csv"
        );
      } else if (isPdf) {
        await exportData(
          dataForExport,
          `Filtered_Bills_${getCurrentDate()}`,
          "pdf"
        );
      }
    } catch (error) {
      console.error("Export error:", error);
      alert("An error occurred during export. Please try again.");
    } finally {
      setIsDownloading(false);
      setExportDataReady(false);
      setIsCsv(false);
      setIsPdf(false);
      setExportDataCache(null);
    }
  };

  return (
    <div className="row py-3 g-0">
      <div className="col-lg text-center text-md-start mb-3 mb-md-0">
        <h6 className="lead mb-0">{sessionInfoForHeader} Session</h6>
        <h2 className="title mb-3 mb-lg-0 me-lg-auto mx-auto text-dark">
          Bill Explorer
        </h2>
      </div>
      <div className="col-lg col-lg-4 d-flex justify-content-end align-items-center mt-0 mt-lg-4">
        <MDBInput
          label="Search Bills..."
          type="text"
          className="bg-white"
          onChange={(e) => {
            setBillSearchText(e.target.value);
            setOffset(0);
          }}
          placeholder="Search Bill/LC #, Short Title, Sponsor (example: HB 100, LC1234)"
        />
      </div>
      <div className="col-auto mt-lg-0 mx-auto mt-3">
        <div className="d-flex justify-content-end helpers">
          <MDBPopover
            tag="a"
            href="#"
            btnChildren={<MDBIcon fas icon="info-circle" />}
            dismiss
            placement="top"
          >
            <MDBPopoverHeader>Quick Search</MDBPopoverHeader>
            <MDBPopoverBody>
              Using the search bar will search text in the displayed columns:
              Bill #, LC # Short Title, and Primary Sponsor. Use the Filters for
              more in-depth searching.
            </MDBPopoverBody>
          </MDBPopover>
          <a
            href="https://leg.mt.gov/bill-info/"
            target="_blank"
            className="ms-1"
          >
            <MDBIcon fas icon="question-circle" />
          </a>
        </div>
        <div className="d-flex justify-content-end align-items-center">
          <MDBBtn
            onClick={() => {
              setSideNavToggle(!sideNavToggle);
            }}
            className="shadow-none ms-1"
          >
            <MDBIcon fas icon="filter" /> Filters
          </MDBBtn>
          <MDBDropdown>
            <MDBDropdownToggle className="shadow-none ms-1">
              <MDBIcon fas icon="cloud-download-alt" /> Export
            </MDBDropdownToggle>
            <MDBDropdownMenu>
              <MDBDropdownItem
                link
                onClick={handleCsvClick}
                disabled={isDownloading}
              >
                Excel/CSV {isDownloading && isCsv ? " (Downloading...)" : ""}
              </MDBDropdownItem>
              <MDBDropdownItem
                link
                onClick={handlePdfClick}
                disabled={isDownloading}
              >
                Print/PDF {isDownloading && isPdf ? " (Downloading...)" : ""}
              </MDBDropdownItem>
            </MDBDropdownMenu>
          </MDBDropdown>
        </div>
      </div>
    </div>
  );
};

export default Header;
